var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Field',_vm._b({attrs:{"options":_vm.options,"type":"select","value":_vm.value},on:{"update:value":function($event){return _vm.$emit('update:value', $event)}}},'Field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }